import axiosInstance from "./axios.instance";
import { setAuthToken } from "./auth.utils";
import { ApiService } from "./api.service";
import apiEndPoints from "../app/routeConfig";

const apiService = new ApiService();

const apiUrl = process.env.REACT_APP_API_URL

export class AuthService {
  async login(data) {
    let result;
    try {
      const response = await axiosInstance.post(apiUrl + 'api/v1/ekutir/user/auth/login/', data);
      if (response) {
        localStorage.setItem("accessToken", response.data.data.accessToken);
        localStorage.setItem('refreshToken', response.data.data.refreshToken);
        localStorage.setItem("userData", JSON.stringify(response.data.data.user));
        setAuthToken();
        result = response.data;
      }
    } catch (error) {
      result = error
    }
    return result
  }
}

export const useLogout = () => {
  const logout = async () => {
    try {
      const response = await apiService.post(`${apiEndPoints.logout}`);
      if (response.statusCode === 200) {
        localStorage.clear();
        sessionStorage.clear();
        return true;
      }
    } catch (error) {
      throw error;
    }
  };
  return { logout };
};

